import { RootState } from "../../redux/store";
import { useAppSelector } from "../hooks/hooks";
import { useNotification } from "../hooks/useNotification";
import { creatorWindowMessageBox } from "./WindowMessageBox/creatorWindowMessageBox";

const WindowsFactory = () => {
    const notification = useAppSelector((state: RootState) => state.notification);
    const { clearNotification } = useNotification();

    return (
        <>
            {notification.open &&
                creatorWindowMessageBox(
                    {
                        handleClose: clearNotification,
                        ...notification
                    }
                )
            }
        </>
    );
};

export default WindowsFactory